import Android from '../../componnets/andriod/Android'
import BannerHome from '../../componnets/banner-home/BannerHome'
import Comment from '../../componnets/comment/Comment'
import Event from '../../componnets/event/Event'
import Texthome1 from '../../componnets/texthome1/Texthome1'
import Windows from '../../componnets/windows/Windows'
import './home.css'
export default function Home(props){
    return(
        <div className='homepage'>
            <BannerHome setLoading={props.setLoading} setSelectnav={props.setSelectnav} />
            <Texthome1 />
            <div className='platforms'>
            <Android />
            <Windows />
            </div>
            <Event setSelectnav={props.setSelectnav} />
            <Comment />
        </div>
    )
}